import { render, staticRenderFns } from "./StoryBoardViewer.vue?vue&type=template&id=1b99c92e&scoped=true"
import script from "./StoryBoardViewer.vue?vue&type=script&lang=js"
export * from "./StoryBoardViewer.vue?vue&type=script&lang=js"
import style0 from "./StoryBoardViewer.vue?vue&type=style&index=0&id=1b99c92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99c92e",
  null
  
)

export default component.exports